import { targetAcosEnabled } from '@/config/targetAcos.js';

export default [
  {
    title: 'PPC',
    channel: 'amazon-ads',
    icon: { icon: 'ic:baseline-ads-click' },
    children: [
      {
        title: 'Dashboard',
        action: 'read',
        subject: 'User',
        to: 'ppc-dashboard',
        icon: { icon: 'ic:outline-dashboard' },
      },
      {
        title: 'Management',
        action: 'read',
        subject: 'User',
        to: { name: 'ppc-analytics-tab', params: { tab: 'campaign' } },
        icon: { icon: 'ri:bar-chart-box-ai-line' },
      },
      {
        title: 'Management v2',
        action: 'read',
        subject: 'User',
        to: { name: 'ppc-management-tab', params: { tab: 'campaign' } },
        icon: { icon: 'lucide:table-properties' },
        envOnly: 'development',
      },
      {
        title: 'Advertised Product',
        action: 'read',
        subject: 'User',
        to: 'ppc-unified-report',
        icon: { icon: 'ic:twotone-table-chart' },
      },
      {
        // Dev-only twin of Advertised Product on the legacy (report v1) dataset, for comparison. The route is
        // hard-blocked outside development by devOnlyPaths in router/index.js.
        title: 'Advertised Product (Legacy)',
        action: 'read',
        subject: 'User',
        to: 'ppc-unified-report-v2',
        icon: { icon: 'ic:twotone-table-chart' },
        envOnly: 'development',
      },
      {
        title: 'Search Terms',
        action: 'read',
        subject: 'User',
        to: 'ppc-unified-search-terms',
        icon: { icon: 'ic:outline-search' },
      },
      {
        title: 'Converted Product',
        action: 'read',
        subject: 'User',
        to: 'ppc-converted-product',
        icon: { icon: 'ic:outline-shopping-bag' },
      },
      {
        // Legacy standalone page, superseded by the unified Search Terms entry above.
        // Nav-only gating: the route stays reachable because the ppc-grid context menu
        // still deep-links to it (contextMenu/searchTerm.js). The dashboard wasted-spend
        // card used to as well; it now opens Unified Search Terms instead.
        title: 'Search Terms',
        action: 'read',
        subject: 'User',
        to: 'ppc-search-terms',
        icon: { icon: 'ic:outline-search' },
        envOnly: 'development',
      },
      {
        title: 'Traffic & Conversion',
        action: 'read',
        subject: 'User',
        to: 'ppc-traffic-conversion',
        icon: { icon: 'ic:outline-swap-horiz' },
      },
      {
        // Dev-only twin of Traffic & Conversion on the legacy datasets, for comparison. The route is
        // hard-blocked outside development by devOnlyPaths in router/index.js.
        title: 'Traffic & Conversion (Legacy)',
        action: 'read',
        subject: 'User',
        to: 'ppc-traffic-conversion-v2',
        icon: { icon: 'ic:outline-swap-horiz' },
        envOnly: 'development',
      },
      {
        title: 'Targeting Report',
        action: 'read',
        subject: 'User',
        to: 'ppc-targeting-report',
        icon: { icon: 'ic:twotone-table-chart' },
        envOnly: 'development',
      },
      {
        title: 'History',
        action: 'read',
        subject: 'User',
        to: 'ppc-history',
        icon: { icon: 'ic:twotone-history' },
      },
      ...(targetAcosEnabled ? [{
        title: 'Performance Targets',
        action: 'read',
        subject: 'User',
        to: 'ppc-performance-targets',
        isNeedBusinessProfile: true,
        icon: { icon: 'ic:outline-track-changes' },
      }] : []),
      {
        title: 'Creative Assets',
        action: 'read',
        subject: 'User',
        to: 'ppc-creative-assets',
        icon: { icon: 'ic:outline-image' },
      },
      {
        title: 'Discover',
        action: 'read',
        subject: 'User',
        to: 'ppc-discover',
        icon: { icon: 'ic:outline-explore' },
      },
    ],
  },
];
